"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.wrapInRange = void 0;

function wrapInRange(index, a, b) {
  if (b) {
    if (b === 0) {
      return index;
    }

    return index < a ? wrapInRange(b + index, a, b) : index >= b ? wrapInRange(index - b, a, b) : index;
  } else {
    if (a === 0) {
      return index;
    }

    return index < 0 ? wrapInRange(a + index, a) : index >= a ? wrapInRange(index - a, a) : index;
  }
}

exports.wrapInRange = wrapInRange;